import * as React from 'react';
import * as blocks from "./style.module.scss";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { styled } from '@mui/material';
import { Modal } from '../../../../../Modal';
import { blocksDataKids } from '../../../data/blocksDataKids';
import { blocksDataTeens } from '../../../data/blocksDataTeens';

const StyledAccordion = styled(Accordion)({
  boxShadow: "unset",
  backgroundColor: "unset",
  marginBottom: "30px",
  "&:last-child": {
    marginBottom: 0,
  },
  "&::before": {
    display: "none",
  },
  "@media (max-width: 991px)": {
    marginBottom: "15px",
  },
});

const StyledSummary = styled(AccordionSummary)({
  background: 'linear-gradient(83.12deg, #9633FB 0.48%, #AC68FF 57.5%, #B881FF 100%)',
  borderRadius: "20px",
  cursor: "pointer",
  padding: "30px",
  width: "100%",
  border: "none",
  textAlign: "left",
  outline: "none",
  fontSize: "15px",
  transition: "0.4s",
  color: '#F2E6FF',
  fontWeight: "400",
  alignItems: "flex-start",
  minHeight: "310px",
  position: "relative",
  "@media (max-width: 991px)": {
    padding: "20px",
    minHeight: "260px",
  },
  "@media (max-width: 767px)": {
    minHeight: "unset",
  },
  "&:after": {
    content: "''",
    position: "absolute",
    top: "calc(50% - 19px)",
    right: "40px",
    width: "43px",
    height: "43px",
    backgroundImage: "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/arrow-down.svg)",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    "@media (max-width: 991px)": {
      top: "20px",
      right: "20px",
      width: "30px",
      height: "30px",
    },
  },
  "&.Mui-expanded": {
    "&:after": {
      backgroundImage: "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/arrow-up.svg)"
    }
  },
  ".MuiAccordionSummary-content": {
    margin: 0,
    paddingRight: "70px",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 991px)": {
      paddingRight: "35px",
    }
  },
});

const StyledDetails = styled(AccordionDetails)({
  padding: "40px",
  backgroundColor: '#fff',
  overflow: "hidden",
  fontWeight: 300,
  fontSize: "18px",
  lineHeight: "21px",
  "@media (max-width: 600px)": {
    margin: "20px",
  },
  "p": {
    marginBottom: "20px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  "ul": {
    paddingLeft: "20px",
    marginBottom: "40px",
  },
  "ul li": {
    listStyle: "disc",
  },
  "@media (max-width: 991px)": {
    padding: "20px",
  },
  "@media (max-width: 767px)": {
    padding: "10px",
  }
});

export const BlocksAllGrades = ({ buttonText, buttonClassName, buttonAction, widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={blocks.structure} id="structure">
      <div className="container">
        <h2 className={blocks.structure__title}>Краткое содержание курсов</h2>
        <div className={blocks.structure__wrapper}>
          <div className={blocks.structure__blocks}>
            <h3 className={blocks.structure__blocksTitle}>5-7 классы</h3>

            {blocksDataKids.map((elem, index) => (
              <StyledAccordion disableGutters={true} key={index} square>
                <StyledSummary>
                  <div className={blocks.structure__blockHeaderRow}>
                    <div className={blocks.block__num}><p>{elem.bage}</p></div>
                    { elem.amount && <div className={blocks.block__lessonAmount}>{elem.amount}</div> }
                    { elem.duration && <div className={blocks.block__lessonDuration}>{elem.duration}</div> }
                  </div>
                  <div className={blocks.structure__blockHeaderTitle}>
                    {elem.title}
                  </div>
                </StyledSummary>
                <StyledDetails>
                  {elem.description}
                  <div className={blocks.structure__blockBtnWrapper}>
                    {buttonAction === "modal" ?
                      (
                        <button
                          className={buttonClassName}
                          onClick={() => {
                            setShowModal(true);
                          }}
                        >
                          {buttonText}
                        </button>
                      ) : buttonAction === "anchor" ?
                        (
                          <a
                            className={buttonClassName}
                            href={"#user-action"}
                          >
                            {buttonText}
                          </a>
                        ) : null
                    }
                  </div>
                </StyledDetails>
              </StyledAccordion>
            ))}
          </div>
          <div className={blocks.structure__blocks}>
            <h3 className={blocks.structure__blocksTitle}>8-11 классы</h3>
            {blocksDataTeens.map((elem, index) => (
              <StyledAccordion disableGutters={true} key={index} square>
                <StyledSummary>
                  <div className={blocks.structure__blockHeaderRow}>
                    <div className={blocks.block__num}><p>{elem.bage}</p></div>
                    { elem.amount && <div className={blocks.block__lessonAmount}>{elem.amount}</div> }
                    { elem.duration && <div className={blocks.block__lessonDuration}>{elem.duration}</div> }
                  </div>
                  <div className={blocks.structure__blockHeaderTitle}>
                    {elem.title}
                  </div>
                </StyledSummary>
                <StyledDetails>
                  {elem.description}
                  <div className={blocks.structure__blockBtnWrapper}>
                    {buttonAction === "modal" ?
                      (
                        <button
                          className={buttonClassName}
                          onClick={() => {
                            setShowModal(true);
                          }}
                        >
                          {buttonText}
                        </button>
                      ) : buttonAction === "anchor" ?
                        (
                          <a
                            className={buttonClassName}
                            href={"#user-action"}
                          >
                            {buttonText}
                          </a>
                        ) : null
                    }
                  </div>
                </StyledDetails>
              </StyledAccordion>
            ))}
          </div>
        </div>
      </div>
      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
